export const ANCHOR_TAG_HREF_REGEX =
  /href="(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&=]*)/g;

const PROTOCOL_REGEX = /^http[s]?:\/\//;

export function getSanitisedUrl(url: string) {
  if (url && !PROTOCOL_REGEX.test(url)) {
    return `https://${url}`;
  }
  return url;
}
